import type {DesignSelection} from '@Components/social-media/social-media.types';
import type {DesignSelectorTab} from '@Components/design-selector/design-selector.types';
import type {GalleryPageURI} from '@Components/design-gallery/design-gallery.types';

export const UPLOADED_DESIGNS_NEXT_TRIGGER_DELAY_MS = 100;

export interface WizardDesignSelectorPanelProps {
  designsToPublish: DesignSelection[];
  onDesignListChange: (designs: DesignSelection[]) => void;
  onDesignsStaged: (designs: DesignSelection[]) => void;
  designSelectorTab: DesignSelectorTab;
  galleryStartingURI: GalleryPageURI | null;
}
